module.exports = __webpack_public_path__ + "static/media/Sunny.213b7679.jpg";